/* eslint-disable no-unused-vars */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import NotFound from 'pages/404'
import { Layout, Row, Col, BackTop } from "antd";
import { UpOutlined } from '@ant-design/icons';

import PageHeader from "components/PageHeader";
import SideMenu from "components/SideMenu";
// import AdminUser from "pages/AdminUser";
// import Resources from "pages/Resources";
import Service from "pages/Service";
import Login from "pages/Login";

import AgreementTerm from "pages/AgreementTerm";
import AgreementPrivacy from "pages/AgreementPrivacy";
// import FAQ from "pages/FAQ";

// import Forget from "pages/Forget";
// import AccountRecovery from "pages/AccountRecovery";
// import RegisterAgreement from "pages/RegisterAgreement";
// import PrivacyAgreement from "pages/PrivacyAgreement";
// import RegisterAccount from "pages/RegisterAccount";
// import RegisterCompany from "pages/RegisterCompany";
// import RegisterMember from "pages/RegisterMember";
// import RegisterSuccess from "pages/RegisterSuccess";

import Marketdetail from "pages/Marketdetail";
import MarketList from "pages/MarketList";
import Market from "pages/Market";

import AccountBasic from "pages/AccountBasic";
import AccountSetting from "pages/AccountSetting";
import AccountSettingAdd from "pages/AccountSettingAdd";
import AccountSettingDetail from "pages/AccountSettingDetail";
import Password from "pages/Password";
import Point from "pages/Point";
import Cost from "pages/Cost";
import CostDetail from "pages/CostDetail";
import Ticket from "pages/Ticket";
import Reply from "pages/Reply";
import Notice from "pages/Notice";
import ServiceDetail from "pages/ServiceDetail";
import LoginConfirm from "pages/LoginConfirm";
import ContactUs from "pages/ContactUs";
import Contact from "pages/Contact";
import ServiceRedirect from "pages/ServiceRedirect"
import ResendLetter from "pages/ResendLetter"
import ResendToken from "pages/ResendToken"
import SubscriptionResult from "pages/SubscriptionResult";
import Preorder from "pages/Preorder";
import PreorderForm from "pages/PreorderForm";
import Frozen from "pages/Frozen";

// auth驗證頝面部分
// function AuthLayout() {
//   return (
//     <div>
//       <Route path="/auth/login" exact component={Login} />
//       <Redirect from="/auth" to="/auth/login" exact />
//       <Route />
//     </div>
//   );
// }

// 主體頝面部分
const Portal = (store) => {
  return (
    <div>
      <PageHeader/>
      <Layout>
          <Row justify="center">
          <div style={{
              backgroundColor:'#7DB926',
              width:"200px",
              position: "fixed",
              height: "100vh",
              left:"0px"
            }}>
              <SideMenu style={{ position: 'fixed' }}/>
            </div>
            <Col span={20} >
              <Route path='/portal/account/basic' component={AccountBasic}/>
              <Route path='/portal/account/setting' exact component={AccountSetting}/>
              <Route path='/portal/account/add' component={AccountSettingAdd}/>
              <Route path='/portal/account/setting/:id' exact component={AccountSettingDetail}/>
              <Route path='/portal/account/password' component={Password}/>
              <Route path='/portal/service' exact component={Service} />
              <Route path='/portal/service/Detail' exact component={ServiceDetail} />
              <Route path='/portal/subscription/result' exact component={SubscriptionResult} />
              <Route path='/portal/point' exact component={Point} />
              <Route path='/portal/cost' exact component={Cost} />
              <Route path='/portal/cost/Detail' exact component={CostDetail} />
              <Route path='/portal/ticket' exact component={Ticket} />
              <Route path='/portal/reply' exact component={Reply} />
              <Route path='/portal/notice' exact component={Notice} />
              <Route path='/portal/contact' exact component={ContactUs} />
              <Route path='/portal/preorder' exact component={Preorder} />
              {/* <Route path='/portal/resources' exact component={Resources}/> */}
              {/* <Redirect from="/" to="/portal/service" exact /> */}
              {/* <Redirect from="/portal/service/Detail" to="/portal/service" exact /> */}
              <Route />
              <BackTop>
                <div style={{
                  width:'60px',
                  height:'60px',
                  borderRadius:'50%',
                  backgroundColor:'#ffffff',
                  color:'#7DB926',
                  textAlign:'center',
                  cursor: 'pointer',
                  padding:'5px',
                  fontWeight: 900,
                  border:'solid 2px #C7C7C7'
                }}><UpOutlined style={{
                  fontSize: '16px',
                }}/><br/>TOP</div>
              </BackTop>
            </Col>

          </Row>
      </Layout>
    </div>   
  )
}

// redirect 路徑 => 若沒有登入則轉至登入畫面
const GuardedRoute = ({ component: Component, store, ...rest }) => (
  <Route {...rest} render={(props) => (
      // store.getState().LoginInfo.isAuthenticated === true
      JSON.parse(localStorage.getItem('LoginInfo')) !== null || JSON.parse(sessionStorage.getItem('isLogin'))
          ? <Component {...props} />
          : <Redirect to='/' />
  )} />
)

// 主體架構 => 將auth頝面與主體頝面分開
function Layouts(store) {
  return (
    <Switch>
      {/* <Route path="*" component={Frozen} /> */}
      {/* <Route path="/auth" component={AuthLayout} /> */}
      {/* <Route path="/forgetpassword" component={Forget} />忘記密碼 */}
      {/* <Route path="/ResendLetter" component={ResendLetter}/>重寄註冊成功信 */}
      {/* <Route path="/AccountRecovery" component={AccountRecovery} />帳號救援 */}
      {/* <Route path="/Register/Agreement" component={RegisterAgreement} />會員條款 */}
      {/* <Route path="/Register/Privacy" component={PrivacyAgreement} />隱私權政策 */}
      {/* <Route path="/Register/Account" component={RegisterAccount} />設定管理員帳號 */}
      {/* <Route path="/Register/Company" component={RegisterCompany} />填寫公司資訊 */}
      {/* <Route path="/Register/Member" component={RegisterMember} /> */}
      {/* <Route path="/Register/Success" component={RegisterSuccess} />感謝您的註冊： */}
      {/* <Route path='/Subscribe/preorder' exact component={PreorderForm} />TypeError */}

      {/* <Route path="/Term" component={AgreementTerm} />
      <Route path="/Privacy" component={AgreementPrivacy} /> */}
      {/* <Route path="/FAQ" component={FAQ} /> */}

      <Route path="/" exact component={Market} />
      <Route path="/market/list" component={MarketList} />
      <Route path="/market/detail" component={Marketdetail} />
      {/* <Route path='/market/contact' exact component={Contact} /> */}
      {/* <Route path="/login/confirm" exact component={LoginConfirm} />空白頁面 */}
      {/* <Route path='/portal/service/Redirect' exact component={ServiceRedirect} /> */}
      {/* <Route path='/ValidateResendToken/:token' component={ResendToken} />轉接克服 */}
      {/* <GuardedRoute component={Portal} store={store}/> */}
      {/* <Route exact path="/">
        <Redirect to="/auth/login" />
      </Route> */}
      {/* <Route component={NotFound} /> */}
      <Redirect to="/" />
    </Switch>
  );
}

function RouterSetting(store) {
  return (
    <Layouts {...store}/>
  )
}

export default (RouterSetting)
